import { TaskPriorityBadgeController } from './task-priority-badge.controller'

const component = {
  templateUrl: '/workflow/components/task-priority-badge/task-priority-badge.html?$$REVISION$$',
  bindings: {
    priority: '<',
    variations: '@'
  },
  controllerAs: '$ctrl',
  controller: TaskPriorityBadgeController
}

export const taskPriorityBadge = component
